<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
  <div id="schedule">
    <template v-if="scheduleOnly">
      <Apply/>
    </template>
    <template v-else>
      <div class="schedule-container">
        <UiBox layout="single">
          <template v-slot:nav-left>
            <UiTab
              v-for="(season, key) in seasonList.slice(0,1)"
              :key="key"
              :id="season.id"
              :active="season.id === subSeasonID"
              :data-id="`id-${key}`"
              @click="switchSeason(season.id)"
            >
              <div class="label-box">
                <span class="label-shadow">{{ season.name }}</span>
                <span class="label-text">{{ season.name }}</span>
              </div>
            </UiTab>
          </template>
          <template v-slot:nav-right>
            <div class="nav-right-box">
              <UiButton class="modal-btn calendar" colorType="red-complex" hook @click="handleShowCalendar">
                <i></i>
                <div class="label-box">
                  <span class="label-shadow">赛程日历</span>
                  <span class="label-text">赛程日历</span>
                </div>
              </UiButton>
              <UiButton class="modal-btn prize" colorType="red-complex" hook @click="appStore.openModal({ id: 'schedule-prize' })">
                <i></i>
                <div class="label-box">
                  <span class="label-shadow">奖金规则</span>
                  <span class="label-text">奖金规则</span>
                </div>
              </UiButton>
              <UiButton v-if="showFullRuleBtn" class="modal-btn rule" colorType="red-complex" hook @click="handleShowRule">
                <i></i>
                <div class="label-box">
                  <span class="label-shadow">完整赛制</span>
                  <span class="label-text">完整赛制</span>
                </div>
              </UiButton>

              <div class="switch-match-slot">
                <UiSelect :list="phaseList" :selected-id="currentPhaseId" @switch="switchPhase" />
              </div>
            </div>
          </template>
          <template v-slot:container>
            <div class="arrange-box" ref="arrangeBox">
              <Arrange
                ref="arrange"
                :openScore="openScore"
                :openTeams="openTeams"
                :arrangeList="arrangeList"
                :handleAnchor="handleAnchor"
              >
              </Arrange>
            </div>
          </template>
        </UiBox>
      </div>
      <ScoreList ref="scoreModal"></ScoreList>
      <Teams ref="teamsModal"></Teams>

      <div class="rule-content" @click="showRule = false" v-if="showRule">
        <div
          class="content"
          :style="{
            'background-image': `url(${lg(config, 'season_rule', '')})`,
            transform: `scale(${scale})`,
          }"
          @click="stopPropagation"
        >
          <div class="close" @click="showRule = false"></div>
        </div>
      </div>
      <div class="rule-content" @click="showCalendar = false" v-if="showCalendar">
        <div
          class="content"
          :style="{
            'background-image': `url(${lg(config, 'season_calendar', '')})`,
            transform: `scale(${scale})`,
          }"
          @click="stopPropagation"
        >
          <div class="close" @click="showCalendar = false"></div>
        </div>
      </div>
      <modal-prize />
    </template>
  </div>
</template>

<script setup>
import lg from '@/utils/lg'
import { computed, ref, watch, useTemplateRef } from 'vue'
import { useAppStore, useStageStore } from '@/store'
import { usePrompt } from '@/composables/usePrompt'
import { useConfig, useConfigFlag } from '@/composables/useConfig'
import * as api from "@/service/index";
import UiBox from '@/components/ui-box';
import UiTab from '@/components/ui-tab';
import UiButton from '@/components/ui-button';
import UiSelect from "@/components/ui-select";
import Arrange from "@/views/schedule/arrange";
import ScoreList from "@/views/schedule/score";
import Teams from "@/views/schedule/teams";
import ModalPrize from './prize'
import Apply from '@/views/apply/index';

const scoreModal = useTemplateRef('scoreModal');
const teamsModal = useTemplateRef('teamsModal');

function openScore(code, title) {
  scoreModal.value.initMatchDetail(code, title);
}
function openTeams(teams) {
  teamsModal.value.initTeams(teams);
}

const appStore = useAppStore();
const stageStore = useStageStore();
const { showPrompt } = usePrompt();

const dateZh = ref(["日", "一", "二", "三", "四", "五", "六"]);
const seasonList = ref([]);
const subSeasonID = ref("");
const subSeasonRule = ref("");
const phaseList = ref([]);
const arrangeList = ref([]);
const currentTime = ref("");

const currentPhaseId = ref("");
// defaultID: '',
const showRule = ref(false);
const showCalendar = ref(false);
const hasLoadedScheduleData = ref(false);

// 模板 ref
const arrangeBox = ref(null);
const arrange = ref(null);

const token = computed(() => appStore.token);
const scale = computed(() => appStore.scale);
const seasonInfo = computed(() => appStore.seasonInfo);
const scheduleOnly = computed(() => stageStore.scheduleOnly);
const config = useConfig();

const showFullRuleBtn = useConfigFlag('season_rule_show')

function ensureScheduleReady() {
  if (hasLoadedScheduleData.value || scheduleOnly.value || !token.value) {
    return;
  }
  hasLoadedScheduleData.value = true;
  requireSeasons();
}
function requireSeasons() {
  // 先请求赛季列表seasonList, 包含所有赛季，以及每个赛季设置的比赛阶段
  if(!token.value) return;
  api.reqArrangeSeasons({ token: token.value }).then((response) => {
    if (response.status === 200) {
      // 所以赛季信息
      seasonList.value = response.data;
      // console.log('this.seasonList',this.seasonList)
      // 获取当前服务器时间
      api.reqcurrentTime().then((response) => {
        if (response.status === 200) {
          currentTime.value = new Date(response.data).getTime();
        } else {
          currentTime.value = new Date();
        }
        const fallbackSeasonId = subSeasonID.value || seasonList.value[0]?.id || '';
        if (fallbackSeasonId) {
          switchSeason(fallbackSeasonId);
        }
      });
    } else {
      showPrompt(response.data);
    }
  });
}
function switchSeason(id) {
  let subSeason = seasonList.value.find((season) => season.id === id);
  if (subSeason) {
    // 当前赛季ID
    subSeasonID.value = subSeason.id;
    // 当前赛季规则
    subSeasonRule.value = subSeason.systemLink;
    // 当前赛季阶段
    phaseList.value = subSeason.categoryList || [];
    if (!phaseList.value.find((phase) => phase.id === "all")) {
      phaseList.value.unshift({
        id: "all",
        name: "全阶段",
      });
    }
    // 当前赛季安排
    let arrangeList_ = [];
    let temp_day_list = [];
    subSeason.scheduleList.forEach((schedule) => {
      // 格式化每天的安排
      let dateObj = new Date(schedule.startAt);
      let day = formatDay(dateObj);
      if (temp_day_list.indexOf(day) === -1) {
        let phase = phaseList.value.find(
          (phase) => phase.id === schedule.categoryId
        )
        if(!phase) return;

        let dayBox = {};
        dayBox.day = day;
        dayBox.week = `周${dateZh.value[dateObj.getDay()]}`;
        dayBox.title = phase.name;
        dayBox.categoryId = schedule.categoryId;

        dayBox.categoryList = [];

        arrangeList_.push(dayBox);
        temp_day_list.push(day);
      }

      // 格式化每个赛程的安排
      let category = {};
      category.time = formatTime(dateObj);
      category.title = schedule.name;
      category.teams = schedule.teamList;
      if (currentTime.value < new Date(schedule.startAt)) {
        category.status = 1;
      } else if (
        currentTime.value >= new Date(schedule.startAt) &&
        currentTime.value <= new Date(schedule.endAt)
      ) {
        category.status = 2;
      } else {
        category.status = 3;
      }
      category.scheduleCode = schedule.scheduleCode;

      // 添加到对应那天的赛程安排中
      arrangeList_
        .find((arrange) => arrange.day === day)
        .categoryList.push(category);
    });
    arrangeList.value = arrangeList_;

    // 新赛季默认选中第一个阶段 ("全阶段"), 触发 arrange 组件初始化
    if (phaseList.value.length) {
      switchPhase(phaseList.value[0].id);
    }
  }
}
function formatDay(dateObj) {
  let month = dateObj.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = dateObj.getDate();
  day = day < 10 ? "0" + day : day;

  return `${month}月${day}日`;
}
function formatTime(dateObj) {
  let hour = dateObj.getHours();
  hour = hour < 10 ? "0" + hour : hour;
  let min = dateObj.getMinutes();
  min = min < 10 ? "0" + min : min;
  return `${hour}:${min}`;
}
function switchPhase(id) {
  currentPhaseId.value = id;
  arrange.value?.switchPhase(id);

  // 埋点
  if (typeof tapdb === "undefined") return;
  tapdb.trackEvent("切换阶段");
}
function stopPropagation(e) {
  e.stopPropagation();
}
function handleShowRule() {
  showRule.value = true;
}
function handleShowCalendar() {
  showCalendar.value = true;
}
function handleAnchor(offsetLeft) {
  arrangeBox.value.scrollLeft = offsetLeft;
}

watch(seasonInfo, (newVal) => {
  if (newVal && newVal.id) {
    subSeasonID.value = newVal.id;
    if (seasonList.value.length) {
      switchSeason(newVal.id);
    }
  }
}, { immediate: true, deep: true });
watch(token, () => {
  ensureScheduleReady()
}, { immediate: true });
watch(scheduleOnly, () => {
  ensureScheduleReady()
}, { immediate: true });
</script>

<style lang="scss" scoped>
#schedule {
  height: 100%;

  .schedule-container {
    height: 100%;

    :deep(.ui-box) {
      .ui-tab {
        padding: 3% 12% 0 0;
        .label-box {
          .label-text { color: #fff; }
          .label-shadow { color: #A31813; }
        }
      }
    }

    .nav-right-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .modal-btn {
        @include r(width, 130);
        @include r(height, 40);
        @include r(font-size, 20);
        @include r(margin-right, 10);
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        @include boxShadowSet_Btn;
        i {
         display: inline-block;
         @include r(width, 25);
         @include r(height, 25);
         @include r(margin-right, 5);
        }

        &.prize {
          i {
            @include icon_status('btn_reward');
          }
        }

        &.rule {
          i {
            @include icon_status('btn_match');
          }
        }

        &.calendar {
          i {
            @include icon_status('btn_calendar');
          }
        }
      }

      .switch-match-slot {
        position: relative;
        @include r(width, 155);
        @include r(height, 36);
        z-index: 10;
      }
    }

    .arrange-box {
      box-sizing: border-box;
      height: 100%;
      padding-top: get_vh(88);
      margin-inline: get_vw(22);
      overflow-x: scroll;
      overflow-y: hidden;
    }

    @include hideScrollBar;
  }

  .rule-content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 50;

    .content {
      position: absolute;
      width: 1286px;
      height: 724px;
      top: 50%;
      left: 50%;
      margin-left: -0.5 * 1286px;
      margin-top: -0.5 * 724px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;

      .close {
        background-image: $icon_close;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: 51px;
        height: 28px;
        position: absolute;
        top: 0;
        right: -50px;
        -webkit-tap-highlight-color: transparent;
      }
    }
  }
}
</style>
